import React, { useCallback, useEffect } from "react";
import general from "../styles/General.module.scss";
import { useGlobalContext } from "../contextProvider/ContextProvider";

const BottomNavigation = ({ currentComponent }) => {
  const {
    configuratorId,
    setCurrentStep,
    currentStep,
    totalSteps,
    submitted,
    isDateSelected,
    setInputSummary,
    inputSummary,
    setSubmitted,
    setSuccessful,
  } = useGlobalContext();

  const increaseStep = useCallback(async () => {
    const requiredFields = document.querySelectorAll(".required");
    const calendar = document.querySelector(".calendar");
    let allFieldsFilled = true;

    const showHint = (message, element) => {
      let existingHint = element.nextElementSibling;
      if (existingHint && existingHint.tagName === "P") {
        existingHint.innerText = message;
      } else {
        const textHint = document.createElement("p");
        textHint.innerText = message;
        textHint.classList.add("textHint");
        textHint.style.color = "red";
        textHint.style.margin = "0";
        textHint.style.fontSize = "0.8rem";
        textHint.style.fontWeight = "normal";
        textHint.style.paddingTop = "25px";

        if (element.classList.contains("calendar")) {
          element.parentNode.parentNode.insertBefore(
            textHint,
            element.nextSibling
          );
        } else {
          element.after(textHint);
        }
      }
      if (
        currentComponent !== "Baustellenadresse" &&
        currentComponent !== "Rechnungsadresse"
      ) {
        element.style.border = "2px solid red";
      }
    };

    const removeHint = (element) => {
      const existingHint = element.nextElementSibling;
      if (existingHint && existingHint.tagName === "P") {
        existingHint.remove();
      }
      element.style.border = "2px solid #0EB660";
    };

    requiredFields.forEach((field) => {
      let errorMessages = [];

      if (
        (field.tagName === "INPUT" &&
          field.type !== "checkbox" &&
          field.type !== "radio") ||
        field.tagName === "TEXTAREA"
      ) {
        if (field.value === "") {
          errorMessages.push("Dieses Feld ist ein Pflichtfeld.");
          allFieldsFilled = false;
        }

        if (field.hasAttribute("maxlength")) {
          const maxLength = field.getAttribute("maxlength");
          if (field.value.length > maxLength) {
            errorMessages.push(`Maximal ${maxLength} Zeichen erlaubt.`);
            allFieldsFilled = false;
          }
        }

        if (field.hasAttribute("max")) {
          const max = parseInt(field.getAttribute("max"));
          const val = parseInt(field.value);
          if (val > max) {
            errorMessages.push(`Maximal ${max} erlaubt.`);
            allFieldsFilled = false;
          }
        }

        if (field.hasAttribute("min")) {
          const min = parseInt(field.getAttribute("min"));
          const val = parseInt(field.value);
          if (val < min) {
            errorMessages.push(`Minimal ${min} erlaubt.`);
            allFieldsFilled = false;
          }
        }

        if (errorMessages.length > 0) {
          showHint(errorMessages.join(" "), field);
        } else {
          removeHint(field);
        }
      } else if (
        field.tagName === "INPUT" &&
        (field.type === "checkbox" || field.type === "radio")
      ) {
        const fieldGroup = document.querySelectorAll(
          `input[name="${field.name}"]`
        );
        const isChecked = Array.from(fieldGroup).some((input) => input.checked);

        const container = field.closest(".choices-container");
        if (container) {
          const existingHint = container.nextElementSibling;
          if (!isChecked) {
            if (!existingHint || existingHint.tagName !== "P") {
              const textHint = document.createElement("p");
              textHint.innerText = "Dieses Feld ist ein Pflichtfeld.";
              textHint.classList.add("textHint");
              textHint.style.color = "red";
              textHint.style.margin = "0";
              textHint.style.fontSize = "0.8rem";
              textHint.style.fontWeight = "normal";
              container.parentNode.insertBefore(
                textHint,
                container.nextSibling
              );
            }
            allFieldsFilled = false;
          } else {
            if (existingHint && existingHint.tagName === "P") {
              existingHint.remove();
            }
          }
        }
      }
    });

    if (calendar) {
      if (isDateSelected === false) {
        showHint("Dieses Feld ist ein Pflichtfeld.", calendar);
        allFieldsFilled = false;
      }
    }

    let correctAddress = true;
    if (currentComponent === "Baustellenadresse") {
      const addressToValidate = `${(
        inputSummary?.["strasse-baustellenadresse"] || ""
      ).trim()}, ${(inputSummary?.["plz-baustellenadresse"] || "").trim()} ${(
        inputSummary?.["ort-baustellenadresse"] || ""
      ).trim()}`;

      try {
        const response = await fetch(
          `https://pedotherm.studio-horn.de/api/geocode`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ address: addressToValidate }),
          }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || "Failed to validate address");
        }

        // If we reach here, the address is correct
        correctAddress = true;
      } catch (error) {
        console.error("Error validating address:", error);
        correctAddress = false;
        const baustellenAdresse = document.querySelector(
          "input[name='ort-baustellenadresse']"
        );
        // Handle the error (e.g., show an error message to the user)
        showHint(
          "Die eingegebene Adresse ist ungültig. Bitte überprüfen Sie Ihre Eingabe.",
          baustellenAdresse
        );
      }
    }

    if (allFieldsFilled && correctAddress) {
      // first trim all the values
      const trimObjectValues = (obj) => {
        if (typeof obj !== "object" || obj === null) {
          if (typeof obj === "string") {
            const trimmed = obj.trim().replace(/\.+$/, "");
            return trimmed;
          }
          return obj;
        }

        if (Array.isArray(obj)) {
          return obj.map(trimObjectValues);
        }

        return Object.fromEntries(
          Object.entries(obj).map(([key, value]) => [
            key,
            trimObjectValues(value),
          ])
        );
      };

      // Then, update the state
      setInputSummary((prevState) => trimObjectValues(prevState));

      // Increase the step
      setCurrentStep(currentStep + 1);
    }
  }, [
    currentStep,
    isDateSelected,
    setCurrentStep,
    setInputSummary,
    inputSummary,
    currentComponent,
  ]);

  const decreaseStep = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // check if all required fields are filled
    const requiredFields = document.querySelectorAll(".required");
    let allFieldsFilled = true;

    requiredFields.forEach((field) => {
      if (
        (field.tagName === "INPUT" &&
          field.type !== "checkbox" &&
          field.type !== "radio") ||
        field.tagName === "TEXTAREA"
      ) {
        if (field.value === "") {
          allFieldsFilled = false;
          const existingHint = field.nextElementSibling;
          if (existingHint && existingHint.tagName === "P") {
            existingHint.innerText = "Dieses Feld ist ein Pflichtfeld";
          } else {
            const textHint = document.createElement("p");
            textHint.innerText = "Dieses Feld ist ein Pflichtfeld";
            textHint.classList.add("textHint");
            textHint.style.color = "red";
            textHint.style.margin = "0";
            textHint.style.fontSize = "0.8rem";
            textHint.style.fontWeight = "normal";
            textHint.style.paddingTop = "15px";
            field.after(textHint);
          }
          field.style.border = "2px solid red";
        } else {
          const existingHint = field.nextElementSibling;
          if (existingHint && existingHint.tagName === "P") {
            existingHint.remove();
          }
          field.style.border = "2px solid #0EB660";
        }
      } else if (
        field.tagName === "INPUT" &&
        (field.type === "checkbox" || field.type === "radio")
      ) {
        if (field.type === "checkbox") {
          const container = field.closest(".choices-container");
          if (!field.checked) {
            allFieldsFilled = false;
            const existingHint = field.nextElementSibling;
            if (existingHint && existingHint.tagName === "P") {
              existingHint.innerText = "Dieses Feld ist ein Pflichtfeld";
            } else {
              const textHint = document.createElement("p");
              textHint.innerText = "Dieses Feld ist ein Pflichtfeld";
              textHint.classList.add("textHint");
              textHint.style.color = "red";
              textHint.style.margin = "0";
              textHint.style.fontSize = "0.8rem";
              textHint.style.fontWeight = "normal";
              container.parentNode.insertBefore(
                textHint,
                container.nextSibling
              );
            }
          } else {
            const existingHint = field.nextElementSibling;
            if (existingHint && existingHint.tagName === "P") {
              existingHint.remove();
            }
          }
        } else {
          const fieldGroup = document.querySelectorAll(
            `input[name="${field.name}"]`
          );
          const isChecked = Array.from(fieldGroup).some(
            (input) => input.checked
          );
          if (!isChecked) {
            allFieldsFilled = false;
            const container = field.closest(".choices-container");
            const existingHint = container.nextElementSibling;
            if (existingHint && existingHint.tagName === "P") {
              existingHint.innerText = "Dieses Feld ist ein Pflichtfeld";
            } else {
              const textHint = document.createElement("p");
              textHint.innerText = "Dieses Feld ist ein Pflichtfeld";
              textHint.classList.add("textHint");
              textHint.style.color = "red";
              textHint.style.margin = "0";
              textHint.style.fontSize = "0.8rem";
              textHint.style.fontWeight = "normal";
              container.parentNode.insertBefore(
                textHint,
                container.nextSibling
              );
            }
          } else {
            const container = field.closest(".choices-container");
            const existingHint = container.nextElementSibling;
            if (existingHint && existingHint.tagName === "P") {
              existingHint.remove();
            }
          }
        }
      }
    });

    if (!allFieldsFilled) {
      return;
    }

    let correctAddress = true;
    if (
      currentComponent === "Rechnungsadresse" &&
      inputSummary["wieBaustellenadresse"] === false
    ) {
      const addressToValidate = `${(
        inputSummary?.["strasse-rechnungsadresse"] || ""
      ).trim()}, ${(inputSummary?.["plz-rechnungsadresse"] || "").trim()} ${(
        inputSummary?.["ort-rechnungsadresse"] || ""
      ).trim()}`;

      try {
        const response = await fetch(
          `https://pedotherm.studio-horn.de/api/geocode`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ address: addressToValidate }),
          }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || "Failed to validate address");
        }

        // If we reach here, the address is correct
        correctAddress = true;
      } catch (error) {
        console.error("Error validating address:", error);
        correctAddress = false;
        // Handle the error (e.g., show an error message to the user)
        alert(
          "Die eingegebene Adresse ist ungültig. Bitte überprüfen Sie sie."
        );
      }
    }

    if (correctAddress) {
      try {
        const formData = new FormData();
        for (const key in inputSummary) {
          formData.append(key, inputSummary[key]);
        }

        //add konfigurator id
        formData.append("id", configuratorId);

        const response = await fetch(
          `${process.env.REACT_APP_API}/api/submit`,
          {
            method: "POST",
            body: formData,
          }
        );
        if (!response.ok) {
          setSubmitted(true);
          setSuccessful(false);
          throw new Error("Failed to submit form");
        }
        setSubmitted(true);
        setSuccessful(true);
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
  };

  useEffect(() => {
    const textHints = document.querySelectorAll(".textHint");
    textHints.forEach((hint) => hint.remove());
  }, [currentStep, totalSteps]);

  // listen for enter press

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        increaseStep();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [currentStep, increaseStep]);

  return (
    <div className={general.bottomNavigation}>
      {currentStep > 1 && !submitted ? (
        <button className={general.prev} onClick={() => decreaseStep()}>
          zurück
        </button>
      ) : null}

      {currentStep < totalSteps ? (
        <button className={general.next} onClick={() => increaseStep()}>
          weiter
        </button>
      ) : null}

      {currentStep === totalSteps && !submitted ? (
        <button
          className={`${general.greenButton} ${general.submitButton}`}
          style={{ marginTop: "50px" }}
          onClick={handleSubmit}
        >
          Absenden
        </button>
      ) : null}
    </div>
  );
};

export default BottomNavigation;
